import { css } from '../../styles/theme';

export const StylesAP = css``;
